(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', 'prop-types'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes);
    global.SiteSelector = mod.exports;
  }
})(this, function (exports, _react, _propTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var SiteSelector = function (_React$Component) {
    _inherits(SiteSelector, _React$Component);

    function SiteSelector(props) {
      _classCallCheck(this, SiteSelector);

      var _this = _possibleConstructorReturn(this, (SiteSelector.__proto__ || Object.getPrototypeOf(SiteSelector)).call(this, props));

      _this.state = {
        expanded: false,
        mobileExpanded: false,
        hover: false,
        americas: false,
        europe: false,
        asia: false,
        africa: false
      };
      _this.toggleExpanded = _this.toggleExpanded.bind(_this);
      _this.handleHover = _this.handleHoverEvent.bind(_this);
      _this.toggleAmericas = _this.toggleAmericas.bind(_this);
      _this.toggleEurope = _this.toggleEurope.bind(_this);
      _this.toggleAsia = _this.toggleAsia.bind(_this);
      _this.toggleAfrica = _this.toggleAfrica.bind(_this);
      return _this;
    }

    _createClass(SiteSelector, [{
      key: 'toggleExpanded',
      value: function toggleExpanded() {
        var currentState = this.state.expanded;
        this.setState({ expanded: !currentState });
      }
    }, {
      key: 'handleHoverEvent',
      value: function handleHoverEvent() {
        this.setState({
          hover: !this.state.hover
        });
      }
    }, {
      key: 'toggleAmericas',
      value: function toggleAmericas() {
        this.setState({
          americas: !this.state.americas
        });
      }
    }, {
      key: 'toggleEurope',
      value: function toggleEurope() {
        this.setState({
          europe: !this.state.europe
        });
      }
    }, {
      key: 'toggleAsia',
      value: function toggleAsia() {
        this.setState({
          asia: !this.state.asia
        });
      }
    }, {
      key: 'toggleAfrica',
      value: function toggleAfrica() {
        this.setState({
          africa: !this.state.africa
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var siteSelector = {
          height: '52px',
          width: '30px',
          overflow: 'hidden',
          margin: '23px 5px 0 5px',
          float: 'right',
          backgroundImage: 'url("https://www.concur.com/sites/all/modules/custom_concur/concur_site_selector/images/' + this.props.lang.substring(3) + '.svg")',
          backgroundRepeat: 'no-repeat',
          backgroundSize: '30px'
        };
        var siteSelectorButton = {
          height: '52px',
          width: '30px',
          overflow: 'hidden',
          float: 'right',
          border: 'none',
          position: 'absolute'
        };
        var siteSelectorExpanded = {
          height: '52px',
          width: '30px',
          margin: '23px 5px 0 5px',
          float: 'right',
          backgroundImage: 'url("https://www.concur.com/sites/all/modules/custom_concur/concur_site_selector/images/' + this.props.lang.substring(3) + '.svg")',
          backgroundRepeat: 'no-repeat',
          backgroundSize: '30px',
          borderBottom: '4px solid #f0ab00',
          overflow: 'auto'
        };
        var siteSelectorDropdown = {
          maxHeight: '0',
          height: 'auto',
          top: '75px',
          backgroundColor: '#333',
          transition: 'all 0.25s ease-in-out',
          overflow: 'hidden',
          cursor: 'default',
          width: '688px',
          position: 'absolute',
          right: '75px'
        };
        var siteSelectorDropdownExpanded = {
          maxHeight: '100vh',
          height: 'auto',
          top: '75px',
          backgroundColor: '#333',
          transition: 'all 0.25s ease-in-out',
          overflow: 'hidden',
          cursor: 'default',
          width: '688px',
          position: 'absolute',
          right: '75px'
        };
        var siteSelectorDropdownMobile = {
          maxHeight: '0',
          height: 'auto',
          top: '75px',
          backgroundColor: '#333',
          transition: 'all 0.25s ease-in-out',
          overflow: 'hidden',
          cursor: 'default',
          width: '688px',
          position: 'absolute',
          right: '75px'
        };
        var siteSelectorDropdownExpandedMobile = {
          top: '75px',
          backgroundColor: '#333',
          overflow: 'hidden',
          cursor: 'default',
          width: '60vw',
          position: 'absolute',
          right: '-15px',
          transition: 'none',
          height: '1400px'
        };
        var regionHeader = {
          color: '#f0ab00',
          textTransform: 'uppercase',
          fontSize: '19px',
          margin: '10px 0 15px',
          fontWeight: '100',
          paddingBottom: '5px'
        };
        var regionHeaderMobile = {
          color: '#fff',
          textTransform: 'uppercase',
          fontSize: '19px',
          margin: '10px 0 15px',
          fontWeight: '100',
          paddingBottom: '5px'
        };
        var regionHeaderMobile2 = {
          color: '#fff',
          textTransform: 'uppercase',
          fontSize: '19px',
          margin: '10px 0 15px',
          fontWeight: '100',
          paddingBottom: '5px',
          borderBottom: '2px solid #f0ab00'
        };
        var linkStyles = {
          color: '#fff',
          display: 'block',
          fontSize: '14px',
          marginBottom: '20px',
          fontWeight: '100',
          textDecoration: 'underline'
        };
        var divContainer = {
          maxHeight: '0',
          height: 'auto',
          overflow: 'hidden',
          transition: 'all 0.25s ease-in-out'
        };

        return _react2.default.createElement(
          'div',
          {
            className: 'site-selector',
            style: this.state.expanded ? siteSelectorExpanded : siteSelector,
            onMouseEnter: this.handleHover,
            onMouseLeave: this.handleHover
          },
          _react2.default.createElement('div', {
            style: siteSelectorButton,
            onClick: this.toggleExpanded
          }),
          _react2.default.createElement(
            'div',
            {
              className: 'site-selector-dropdown',
              style: this.props.isMobile ? this.state.expanded ? siteSelectorDropdownExpandedMobile : siteSelectorDropdownMobile : this.state.expanded ? siteSelectorDropdownExpanded : siteSelectorDropdown
            },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12 flush-xs' },
              _react2.default.createElement(
                'div',
                { className: 'col-lg-4' },
                _react2.default.createElement(
                  'p',
                  { className: 'region-header',
                    style: this.props.isMobile ? this.state.americas ? regionHeaderMobile2 : regionHeaderMobile : regionHeader,
                    onClick: this.toggleAmericas
                  },
                  'Americas'
                ),
                _react2.default.createElement(
                  'div',
                  { style: this.props.isMobile ? this.state.americas ? {} : divContainer : {} },
                  _react2.default.createElement(
                    'a',
                    { style: linkStyles, href: 'https://www.concur.com' },
                    'United States (English)'
                  ),
                  _react2.default.createElement(
                    'a',
                    { style: linkStyles, href: 'https://www.concur.ca' },
                    'Canada (English)'
                  ),
                  _react2.default.createElement(
                    'a',
                    { style: linkStyles, href: 'https://www.concur.ca/fr' },
                    'Canada (Fran\xE7ais)'
                  ),
                  _react2.default.createElement(
                    'a',
                    { style: linkStyles, href: 'https://www.concur.com.mx' },
                    'M\xE9xico (Espa\xF1ol)'
                  ),
                  _react2.default.createElement(
                    'a',
                    { style: linkStyles, href: 'https://www.concur.com.br' },
                    'Brasil (Portugu\xEAs)'
                  ),
                  _react2.default.createElement(
                    'a',
                    { style: linkStyles, href: 'https://www.concur.com.ar' },
                    'Argentina (Espa\xF1ol)'
                  ),
                  _react2.default.createElement(
                    'a',
                    { style: linkStyles, href: 'https://www.concur.co' },
                    'Colombia (Espa\xF1ol)'
                  ),
                  _react2.default.createElement(
                    'a',
                    { style: linkStyles, href: 'https://www.concur.cl' },
                    'Chile (Espa\xF1ol)'
                  ),
                  _react2.default.createElement(
                    'a',
                    { style: linkStyles, href: 'https://www.concur.pe' },
                    'Peru (Espa\xF1ol)'
                  )
                ),
                _react2.default.createElement(
                  'p',
                  { className: 'region-header',
                    style: this.props.isMobile ? this.state.africa ? regionHeaderMobile2 : regionHeaderMobile : regionHeader,
                    onClick: this.toggleAfrica
                  },
                  'Middle East and Africa'
                ),
                _react2.default.createElement(
                  'div',
                  { style: this.props.isMobile ? this.state.africa ? {} : divContainer : {} },
                  _react2.default.createElement(
                    'a',
                    { style: linkStyles, href: 'https://www.concur.co.za' },
                    'South Africa (English)'
                  ),
                  _react2.default.createElement(
                    'a',
                    { style: linkStyles, href: 'https://www.concur.ae' },
                    'United Arab Emirates (English)'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-lg-4' },
                _react2.default.createElement(
                  'p',
                  { className: 'region-header',
                    style: this.props.isMobile ? this.state.europe ? regionHeaderMobile2 : regionHeaderMobile : regionHeader,
                    onClick: this.toggleEurope
                  },
                  'Europe'
                ),
                _react2.default.createElement(
                  'div',
                  { style: this.props.isMobile ? this.state.europe ? {} : divContainer : {} },
                  _react2.default.createElement(
                    'a',
                    { style: linkStyles, href: 'https://www.concur.co.uk' },
                    'United Kingdom (English)'
                  ),
                  _react2.default.createElement(
                    'a',
                    { style: linkStyles, href: 'https://www.concur.fr' },
                    'France (Fran\xE7ais)'
                  ),
                  _react2.default.createElement(
                    'a',
                    { style: linkStyles, href: 'https://www.concur.de' },
                    'Deutschland (Deutsch)'
                  ),
                  _react2.default.createElement(
                    'a',
                    { style: linkStyles, href: 'https://www.concur.it' },
                    'Italia (Italiano)'
                  ),
                  _react2.default.createElement(
                    'a',
                    { style: linkStyles, href: 'https://www.concur.nl' },
                    'Nederlands (English)'
                  ),
                  _react2.default.createElement(
                    'a',
                    { style: linkStyles, href: 'https://www.concur.se' },
                    'Sweden (English)'
                  ),
                  _react2.default.createElement(
                    'a',
                    { style: linkStyles, href: 'https://www.concur.dk' },
                    'Denmark (English)'
                  ),
                  _react2.default.createElement(
                    'a',
                    { style: linkStyles, href: 'https://www.concur.fi' },
                    'Finland (English)'
                  ),
                  _react2.default.createElement(
                    'a',
                    { style: linkStyles, href: 'https://www.concur.be' },
                    'Belgium (English)'
                  ),
                  _react2.default.createElement(
                    'a',
                    { style: linkStyles, href: 'https://www.concur.es' },
                    'Espa\xF1a (Espa\xF1ol)'
                  ),
                  _react2.default.createElement(
                    'a',
                    { style: linkStyles, href: 'https://www.concur.no' },
                    'Norway (English)'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-lg-4' },
                _react2.default.createElement(
                  'p',
                  { className: 'region-header',
                    style: this.props.isMobile ? this.state.asia ? regionHeaderMobile2 : regionHeaderMobile : regionHeader,
                    onClick: this.toggleAsia
                  },
                  'Asia Pacific'
                ),
                _react2.default.createElement(
                  'div',
                  { style: this.props.isMobile ? this.state.asia ? {} : divContainer : {} },
                  _react2.default.createElement(
                    'a',
                    { style: linkStyles, href: 'https://www.concur.com.au' },
                    'Australia (English)'
                  ),
                  _react2.default.createElement(
                    'a',
                    { style: linkStyles, href: 'https://www.concur.cn' },
                    '\u4E2D\u56FD\uFF08\u7B80\u4F53\u4E2D\u6587)'
                  ),
                  _react2.default.createElement(
                    'a',
                    { style: linkStyles, href: 'https://www.concur.com.hk' },
                    'Hong Kong SAR of China (English)'
                  ),
                  _react2.default.createElement(
                    'a',
                    { style: linkStyles, href: 'https://www.concur.co.in' },
                    'India (English)'
                  ),
                  _react2.default.createElement(
                    'a',
                    { style: linkStyles, href: 'https://www.concur.co.jp' },
                    '\u65E5\u672C\uFF08\u65E5\u672C\u8A9E)'
                  ),
                  _react2.default.createElement(
                    'a',
                    { style: linkStyles, href: 'https://www.concur.kr' },
                    '\uB300\uD55C\uBBFC\uAD6D (\uD55C\uAD6D\uC5B4)'
                  ),
                  _react2.default.createElement(
                    'a',
                    { style: linkStyles, href: 'https://www.concur.com.sg' },
                    'Singapore (English)'
                  ),
                  _react2.default.createElement(
                    'a',
                    { style: linkStyles, href: 'https://www.concur.tw' },
                    '\u4E2D\u570B\u53F0\u7063 (\u7E41\u9AD4\u4E2D\u6587)'
                  )
                )
              )
            )
          )
        );
      }
    }]);

    return SiteSelector;
  }(_react2.default.Component);

  exports.default = SiteSelector;


  SiteSelector.propTypes = {
    lang: _propTypes2.default.string,
    expanded: _propTypes2.default.bool,
    isMobile: _propTypes2.default.bool
  };

  SiteSelector.defaultProps = {
    lang: 'en-us',
    expanded: false
  };
});